import { TableSizes } from '@shared/floor-plans';

export const DEFAULT_MAX_VALUES = {
  [TableSizes.small]: 2,
  [TableSizes.medium]: 4,
  [TableSizes.large]: 6,
};
